import React, { useState } from 'react';
import { Grid } from '@mui/material/';
import TopToolbar from './toolbar';
import { useSetDocumentTitle } from '../api/useSetDocumentTitle';
import * as css from './index.module.scss';
import classNames from 'classnames';
import { Footer } from './footer';

interface Props {
  documentTitle?: string;
  title: string;
  subtitle?: string;
  menuItems?: React.ReactNode;
  actionItems?: React.ReactNode;
  titleActions?: React.ReactNode;
  isIndented: boolean;
  isFullScreen?: boolean;
  className?: string;
}

const PageLayout: React.FC<React.PropsWithChildren<Props>> = ({
  documentTitle,
  title,
  subtitle,
  menuItems,
  actionItems,
  isIndented,
  children,
  titleActions,
  className,
  isFullScreen,
}) => {
  useSetDocumentTitle(documentTitle || title);
  const breakPoint = 960;
  const [menuShouldbreak, setMenuShouldbreak] = useState<boolean>(
    window.innerWidth < breakPoint,
  );

  React.useEffect(() => {
    const handleResize = () => {
      setMenuShouldbreak(window.innerWidth < breakPoint);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <TopToolbar
        title={title}
        subtitle={subtitle}
        menuItems={menuItems}
        actionItems={actionItems}
        titleActions={titleActions}
        permanentMenu={!(isFullScreen || menuShouldbreak)}
      />
      <div
        className={classNames(
          className,
          isFullScreen || menuShouldbreak ? css.contentMobile : css.content,
        )}
      >
        <main className={css.main}>
          <Grid container>
            {isIndented && (isFullScreen || menuShouldbreak) && (
              <Grid item xs={1} />
            )}
            <Grid item xs>
              {children}
            </Grid>
            {isIndented && <Grid item xs={1} />}
          </Grid>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default PageLayout;
